import { render, staticRenderFns } from "./AssessmentPmpSummaryPanel.vue?vue&type=template&id=36cc1b2a&scoped=true&"
import script from "./AssessmentPmpSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./AssessmentPmpSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentPmpSummaryPanel.vue?vue&type=style&index=0&id=36cc1b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc1b2a",
  null
  
)

export default component.exports